// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__wtxuy","footer":"ModalCreateQualiphyProcedure_footer__1A9fJ","additionData":"ModalCreateQualiphyProcedure_additionData__2U4EX"};